export const delayToolTip = 0.3
